export const environment =  {
  // App configuration
  production: false
};
